import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import VehiclesSubNav from "./VehiclesSubNav";
import { api, fileUrl } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useI18n } from "../../i18n/I18nProvider";
import { FileText } from "lucide-react";

export default function VehicleDocuments() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    if (!user) return;
    api.get("/vehicles").then((r) => setVehicles(r.data || [])).catch(() => {});
  }, [user]);

  if (!user) return <Layout><div className="max-w-[1440px] mx-auto p-10 label-tech">{t("add.loginRequired")}</div></Layout>;

  const rows = vehicles.flatMap((v) =>
    (v.documents || []).map((d, idx) => ({
      vehicle: v,
      path: typeof d === "string" ? d : d.path,
      label: typeof d === "string" ? d : (d.label || d.path),
      uploaded_at: typeof d === "string" ? null : d.uploaded_at,
      idx,
    }))
  );

  return (
    <Layout>
      <div className="max-w-[1440px] mx-auto px-6 pt-10 pb-16">
        <div className="mb-6">
          <div className="label-tech">{t("veh.label")}</div>
          <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tighter mt-2">{t("veh.tab.documents")}</h1>
        </div>

        <VehiclesSubNav />

        <div className="border border-[var(--ink-200)] bg-[var(--bone)]" data-testid="vehicle-documents-table">
          <div className="grid grid-cols-12 gap-2 px-4 py-2 label-tech border-b border-[var(--ink-200)]">
            <div className="col-span-3">{t("veh.regnr")}</div>
            <div className="col-span-6">{t("veh.documents")}</div>
            <div className="col-span-3 text-right">—</div>
          </div>
          {rows.length === 0 ? (
            <div className="p-10 label-tech text-center">{t("vdash.noData")}</div>
          ) : rows.map((r) => (
            <div key={`${r.vehicle.id}-${r.idx}`} className="grid grid-cols-12 gap-2 px-4 py-3 border-b border-[var(--ink-200)] text-sm items-center" data-testid={`doc-row-${r.vehicle.id}-${r.idx}`}>
              <div className="col-span-3">
                <Link to={`/vehicles/${r.vehicle.id}`} className="font-mono-tech underline decoration-dotted">{r.vehicle.regnr}</Link>
              </div>
              <div className="col-span-6 inline-flex items-center gap-2 truncate">
                <FileText size={12} className="shrink-0" /> <span className="truncate">{r.label}</span>
              </div>
              <div className="col-span-3 text-right">
                <a href={fileUrl(r.path)} target="_blank" rel="noreferrer" className="btn-ghost text-xs">{t("card.view")}</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
